// extracted by mini-css-extract-plugin
export default {"stars":"Stars_stars__WXR+p"};